import React from 'react';
import { Link } from "react-router-dom";

export default class Contact extends React.Component {
  render() {
    return (
      <div className="contact white-text">
          <div className="hero">
              <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <h3>
                            With offices across the country, and products and services that extend far beyond, FSDH Merchant Bank is always open to clients both within and outside the Continent.
                            </h3>
                            {/* <p>With offices across the country, and products and services that extend far beyond, FSDH Merchant Bank is always open to clients both within and outside the Continent.</p> */}
                        </div>
                    </div>
                    {/* <br /> */}
                    {/* <div className="row">
                        <div className="order-1 col-6 col-sm-4">
                            <p className="contact-title thin">
                               Help Desk
                            </p> 
                            <p>
                                <a className="white-text thin" href="mailto: help@fsdhgroup.com">help@fsdhgroup.com</a> &nbsp;&nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;&nbsp;<a className="white-text" href="tel: +23410000000">234 1 0000 000</a>
                            </p>
                        </div>
                        <div className="order-3 order-sm-2 col-sm-4">
                            <p className="contact-title thin">
                                Fraud Desk
                            </p> 
                            <p>
                                <a className="white-text thin" href="mailto: help@fsdhgroup.com">frauddesk@fsdhgroup.com</a> &nbsp;&nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;&nbsp;<a className="white-text" href="tel: +23414631453">01-4631453</a>
                            </p>
                        </div>
                        <div className="order-2 order-sm-3 col-6 col-sm-4">
                            <p className="contact-title thin">
                                Feedback
                            </p> 
                            <p>
                                <a className="white-text thin" href="mailto: help@fsdhgroup.com">Reach Across</a>
                            </p>
                        </div>
                    </div> */}
              </div>
          </div>
          <div className="addresses">
              <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-4">
                            <h5>Lagos</h5>
                            <p className="contact-title">
                                UAC House (5th - 8th Floors),<br />
                                1/5 Odunlami Street,<br />
                                Tel: 01-2702885-6<br />
                            </p>
                        </div>
                        <div className="col-sm-4">
                            <h5>Abuja</h5>
                            <p className="contact-title">
                                Ground Floor, Leadway Building<br />
                                Plot 1061, Herbery Macaulay way,<br />
                                Central Business District<br />
                                Abuja Nigeria<br />
                                Tel: 234-9-2918821
                            </p>
                        </div>
                        <div className="col-sm-4">
                            <h5>Port Harcourt</h5>
                            <p className="contact-title">
                            Polaris Bank Building (2nd Floor),<br />
                            5 Trans Amadi Road,<br />
                            Port Harcourt Rivers State<br/>
                                Tel: 0802 408 1331<br />
                            </p> 
                        </div>
                    </div>
              </div>
          </div>
          
          <div className="space"></div>
      </div>
    );
  }
}